// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__yvzyC","label":"Radio_label__3Rt1f","checkMark":"Radio_checkMark__1luKc","disabled":"Radio_disabled__1--Vp"};